module.exports = __webpack_public_path__ + "static/media/laborleiter_checkliste.7acb8399.png";